import Calculated from '../../../types/api/components/calculation-position/calculated'

type CalculatedSource = {
    calculated?: Calculated
    calculatedOnActual?: Calculated
}

function hasCalculatedFields(calculated?: Calculated | null): calculated is Calculated {
    if (!calculated || typeof calculated !== 'object') {
        return false
    }

    return Object.keys(calculated).some(key => key !== 'id' && key !== '__component')
}

export function isShipmentCalculatedOnActual(source?: CalculatedSource | null): boolean {
    return hasCalculatedFields(source?.calculatedOnActual)
}

export function getShipmentDisplayCalculated(
    source?: CalculatedSource | null
): Calculated | undefined {
    if (!source) {
        return undefined
    }

    if (isShipmentCalculatedOnActual(source)) {
        return source.calculatedOnActual
    }

    return source.calculated
}
